import styled from 'styled-components';
import { ITheme } from '../../interfaces/styled';

export interface TitleProps {
  level: '1' | '2' | '3';
}

export type IGetSizeMap = (globalTheme: ITheme) => {
  [ key in TitleProps['level'] ]: number;
};

const getSizeMap: IGetSizeMap = (globalTheme) => ({
  1: globalTheme.fontSize.xxl,
  2: globalTheme.fontSize.xl,
  3: globalTheme.fontSize.lg
});

const Title = styled.div<TitleProps>`
  font-family: ${({ theme }) => theme.family};
  font-size: ${({ level, theme }) => getSizeMap(theme)[level]}px;
  line-height: 1.1;
  letter-spacing: -2px;
  font-weight: 600;
  margin: 0;
`;

export { Title };
